var map = {
	"./logical-reasoning/questions.json": "7d5d",
	"./mechanical-reasoning/questions.json": "4590",
	"./numerical-reasoning/questions.json": "6515",
	"./situational-judgement/questions.json": "9da6",
	"./verbal-reasoning/questions.json": "2b8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e7b";